import React from 'react';
import styled from 'styled-components';

import mag from '../../assets/icons/search.svg';

const Root = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 15px;
`;

function Icon() {
  return <Root src={mag} alt="search" />;
}

export default Icon;
